export class DealerLocatorError extends Error {
  constructor(message) {
    super(message);
    this.name = 'DealerLocatorError';
  }
}

export class ApiResponseError extends Error {
  constructor(message, statusCode, statusText) {
    super(message);
    this.name = 'ApiResponseError';
    this.statusCode = statusCode;
    this.statusText = statusText;
  }
}

export class ConfigurationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ConfigurationError';
  }
}

export class GeolocationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'GeolocationError';
  }
}

export class GeocodeError extends Error {
  constructor(message) {
    super(message);
    this.name = 'GeocodeError';
  }
}

export class I18nError extends Error {
  constructor(message) {
    super(message);
    this.name = 'I18nError';
  }
}
